import React, {
  useRef,
  useState,
  useEffect,
} from "react";
import Webcam from "react-webcam";
import axios from "axios";

import authStore from "../services/authStore";
import "./ScanCard.css";

console.log(
  "ENV URL:",
  process.env.REACT_APP_API_URL
);

const API_BASE_URL = process.env.REACT_APP_API_URL;

const ScanCard = ({
  setResult,
  onClose,
  setOcrLoading,
  mode = "camera",
}) => {
  const webcamRef = useRef(null);

  


  const [cameraFacing, setCameraFacing] =
    useState("environment");


    useEffect(() => {
  return () => {
    const stream =
      webcamRef.current?.video?.srcObject;

    if (stream) {
      stream
        .getTracks()
        .forEach((track) => track.stop());
    }
  };
}, []);
 

  /* ==========================
     BASE64 TO FILE
  ========================== */

  const dataURLtoFile = (
    dataurl,
    filename
  ) => {
    const arr = dataurl.split(",");

    const mime =
      arr[0].match(/:(.*?);/)[1];

    const bstr = atob(arr[1]);

    let n = bstr.length;

    const u8arr =
      new Uint8Array(n);

    while (n--) {
      u8arr[n] =
        bstr.charCodeAt(n);
    }

    return new File(
      [u8arr],
      filename,
      { type: mime }
    );
  };

  /* ==========================
     CAPTURE + OCR API
  ========================== */

  const captureAndScan = async () => {
  try {
    const imageSrc =
      webcamRef.current?.getScreenshot();

    if (!imageSrc) {
      alert("Unable to capture image");
      return;
    }

    // show loader in Enquiry
    setOcrLoading(true);

    // close scanner immediately
    onClose?.();

    const token = authStore.getToken();

    const file = dataURLtoFile(
      imageSrc,
      "business-card.jpg"
    );

    const formData = new FormData();

    formData.append("file", file);

    const response = await axios.post(
      `${API_BASE_URL}/business-card/scan-card`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setResult?.(response.data);

  } catch (error) {

    console.error(error);

    alert(
      JSON.stringify(
        error?.response?.data ||
        error.message
      )
    );

  } finally {

    setOcrLoading(false);
  }
};



  return (


    <div className="scan-card-overlay">



      {mode === "camera" && (
        <Webcam
          key={cameraFacing}
          ref={webcamRef}
          audio={false}
          screenshotFormat="image/jpeg"
          className="scan-card-webcam"
          videoConstraints={{
            facingMode: cameraFacing,
          }}
        />
      )}

      <button
  className="back-btn"
  onClick={onClose}
>
  ✕
</button>

<button
  className="switch-btn"
  onClick={() =>
    setCameraFacing(prev =>
      prev === "user"
        ? "environment"
        : "user"
    )
  }
>
  🔄
</button>

<button
  className="capture-btn"
  onClick={captureAndScan}
/>

      

   

    </div>
  );
};

export default ScanCard;